import { useIntl } from 'react-intl';
import { Chip, Stack, Tooltip, Typography } from '@rossum/ui/material';
import { GridRowId } from '@rossum/ui/x-data-grid-pro';

type SelectedAnnotationsFooterProps = {
  selectedAnnotations: { id: number; name: string }[];
  onRemove: (id: GridRowId) => void;
};

const MAX_CHIP_NUMBER = 3;

export const SelectedAnnotationsFooter = ({
  selectedAnnotations,
  onRemove,
}: SelectedAnnotationsFooterProps) => {
  const intl = useIntl();
  const hasSelections = selectedAnnotations.length > 0;

  const visibleAnnotations = selectedAnnotations.slice(0, MAX_CHIP_NUMBER);
  const hiddenAnnotations = selectedAnnotations.slice(MAX_CHIP_NUMBER);

  return (
    <Stack
      mt="auto"
      direction="row"
      alignItems="center"
      spacing={1}
      minHeight={25}
    >
      {hasSelections ? (
        <>
          <Typography variant="body2">
            {intl.formatMessage({
              id: 'features.customRelations.createDialog.selectionsLabel',
            })}
          </Typography>
          {visibleAnnotations.map(({ id, name }) => (
            <Chip
              key={id}
              label={name}
              onDelete={() => onRemove(id)}
              sx={{ maxWidth: 120, cursor: 'default' }}
            />
          ))}
          {hiddenAnnotations.length ? (
            <Tooltip
              placement="top"
              title={
                <Stack maxHeight={150} overflow="auto">
                  {hiddenAnnotations.map(({ id, name }) => (
                    <Typography key={id} variant="body2">
                      {name}
                    </Typography>
                  ))}
                </Stack>
              }
            >
              <Chip label={`+${hiddenAnnotations.length}`} />
            </Tooltip>
          ) : null}
        </>
      ) : null}
    </Stack>
  );
};
